import { render, staticRenderFns } from "./EditFollowingExport.vue?vue&type=template&id=4b019c0d&"
import script from "./EditFollowingExport.vue?vue&type=script&lang=js&"
export * from "./EditFollowingExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports